import copyToClipboard from '@anm/helpers/copyToClipboard';
import { useEffect, useState } from 'react';

import { CopyLinkProps } from '.';

let cancelTimeout: NodeJS.Timer;

const useCopyLink = ({ link, buttonText }: CopyLinkProps) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (!isCopied) return;

    clearTimeout(cancelTimeout);
    cancelTimeout = global.setTimeout(() => setIsCopied(false), 1500);
  }, [isCopied]);

  const handleClick = () => {
    setIsCopied(true);
    copyToClipboard(link);
  };

  const copyLinkButtonText = isCopied ? 'Copied' : buttonText;

  return { handleClick, copyLinkButtonText, linkToCopy: link };
};

export default useCopyLink;
